import * as React from "react";
import { connect } from "react-redux";
import { RootState } from "src/ipm-shared/store/model/reducers";
import * as selectors from "../selectors";
import { IBaseProps } from "src/ipm-shared/components/Form/controls/lib/Base";
import SelectMultiLevel from "src/ipm-shared/components/Form/controls/SelectMultiLevel";
import Skeleton from "antd/es/skeleton";

import * as actions from "../actions";

type ISelect = {
  SelectComponent?: any;
};

const mapStateToProps = (state: RootState) => ({
  businessOccupations: selectors.getBusinessOccupations(state),
  occupationsGroupName: selectors.getOccupationsGroupName(state),
  isFetchingBusiness: selectors.getIsFetchBusiness(state)
});

const mapDispatchToProps = {
  fetchBusinessOccupations: actions.fetchBusinessOccupations
};

type IProps = IBaseProps &
  ReturnType<typeof mapStateToProps> &
  typeof mapDispatchToProps &
  ISelect;

class SelectBusinessOccupations extends React.Component<IProps> {
  public componentDidMount() {
    this.props.fetchBusinessOccupations();
  }

  public render() {
    const {
      businessOccupations,
      SelectComponent = SelectMultiLevel,
      isFetchingBusiness
    } = this.props;

    businessOccupations.map(b => {
      const otherItems = b.children.filter(l => l.label.indexOf("Other") === 0);
      const restItems = b.children.filter(l => l.label.indexOf("Other") === -1);
      b.children = restItems.concat(otherItems);
    });

    return this.props.businessOccupations.length > 0 ? (
      <Skeleton loading={isFetchingBusiness} paragraph={{ rows: 1 }}>
        <SelectComponent
          placeholder={"Occupation"}
          options={businessOccupations}
          {...this.props}
        />
      </Skeleton>
    ) : (
      <Skeleton loading={true} paragraph={{ rows: 1 }}></Skeleton>
    );
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SelectBusinessOccupations);
